import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import addCarPlateDetailServices from '@src/services/addNewCar/addCarPlateDetail.services';
import costCenterServices from '@src/services/costCenter/costCenter.services';
import uniqBy from 'lodash/uniqBy';
import map from 'lodash/map';

export const getVehicleDepartments = createAsyncThunk(
  'getVehicleDepartments',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = body?.customerId ?? customer?.selectedCustomer?.customerId;
      const providerType = await getState()?.vehicleManagementDetail?.vehicleManagementItem
        .providerType;
      const vouId =
        body?.vouId ?? ((await getState()?.addCarType?.selectVehicleProviderType) || providerType);
      const data = await addCarPlateDetailServices.getVehicleDepartments({ customerId, vouId });
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVehicleFuelTypes = createAsyncThunk(
  'getVehicleFuelTypes',
  async (body, { getState, rejectWithValue }) => {
    try {
      const providerType = await getState()?.vehicleManagementDetail?.vehicleManagementItem
        .providerType;
      const vouId =
        (await getState()?.addCarType?.selectVehicleProviderType) || body?.vouId || providerType;
      const data = await addCarPlateDetailServices.getVehicleFuelTypes({ vouId });
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVehicleCostCenter = createAsyncThunk(
  'getVehicleCostCenter',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = body?.customerId ?? customer?.selectedCustomer?.customerId;
      const providerType = await getState()?.vehicleManagementDetail?.vehicleManagementItem
        .providerType;
      const vouId =
        (await getState()?.addCarType?.selectVehicleProviderType) || body?.vouId || providerType;
      const data = await costCenterServices.getVehicleCostCenter({ customerId, vouId });
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVehicleLimitTypes = createAsyncThunk(
  'getVehicleLimitTypes',
  async ({ vouId, custId }, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = custId ?? customer?.selectedCustomer?.customerId;
      const data = await addCarPlateDetailServices.getVehicleLimitTypes({ customerId, vouId });
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVehicleLimitTypesDayRestrictionOperations = createAsyncThunk(
  'getVehicleLimitTypesDayRestrictionOperations',
  async ({ vouId }, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = customer?.selectedCustomer?.customerId;
      const data = await addCarPlateDetailServices.getVehicleLimitTypes({ customerId, vouId });
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVehicleLimitValueTypes = createAsyncThunk(
  'getVehicleLimitValueTypes',
  async ({ custId }, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = custId ?? customer?.selectedCustomer?.customerId;
      const data = await addCarPlateDetailServices.getVehicleLimitValueTypes({ customerId });
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVehicleTypes = createAsyncThunk(
  'getVehicleTypes',
  async (body, { rejectWithValue }) => {
    try {
      const data = await addCarPlateDetailServices.getVehicleTypes();
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVehicleAttributes = createAsyncThunk(
  'getVehicleAttributes',
  async (body, { rejectWithValue }) => {
    try {
      const data = await addCarPlateDetailServices.getVehicleAttributes();
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVehicleLAddressGetList = createAsyncThunk(
  'getVehicleLAddressGetList',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const vehicleDetailsState = body?.vehicleDetailsState;
      const notUnique = body?.notUnique ?? false;
      const customerId = body?.customerId ?? customer?.selectedCustomer?.customerId;
      const data = await addCarPlateDetailServices.getVehicleLAddressGetList({ customerId });
      const uniqArray = uniqBy(data?.data?.items, (item) => item.addressName);
      let newAddressGetList = map(uniqArray, (item) => ({
        id: item.id,
        name: item.addressName,
        companyAddress: item.companyAddress,
      }));
      if (notUnique) {
        return map(data?.data?.items, (item) => ({
          id: item.id,
          name: item.addressName,
          companyAddress: item.companyAddress,
        }));
      }
      try {
        if (newAddressGetList && vehicleDetailsState) {
          Object.values(vehicleDetailsState).forEach((newItem) => {
            if (
              newAddressGetList.filter(
                (item) => item.name === newItem.address.name && item.id === newItem.address.id,
              ).length === 0
            ) {
              const missing = data?.data?.items.filter((item) => item.id === newItem.address.id);
              const newAdd = map(missing, (item) => ({
                id: item.id,
                name: item.addressName,
                companyAddress: item.companyAddress,
              }));
              if (newAddressGetList.filter((item) => item.id === newAdd[0].id).length === 0)
                newAddressGetList = newAddressGetList.concat(newAdd);
            }
          });
        }
      } catch (errorx) {
        console.error('error', errorx);
      }
      return newAddressGetList;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const postVehicles = createAsyncThunk(
  'postVehicles',
  async ({ vehicles }, { rejectWithValue }) => {
    try {
      const data = await addCarPlateDetailServices.postVehicles({ vehicles });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVehicleForThanksPage = createAsyncThunk(
  'getVehicleForThanksPage',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = body?.customerId ?? customer?.selectedCustomer?.customerId;
      const { vouId, deviceTypeId } = body;
      const data = await addCarPlateDetailServices.getVehicleForThanksPage({
        customerId,
        vouId,
        deviceTypeId,
      });
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  vehicleDepartments: [],
  vehicleCostCenters: [],
  vehicleLimitTypes: [],
  vehicleLimitTypesDayRestrictionOperations: [],
  vehicleFuelTypes: [],
  vehicleLimitValueTypes: [],
  vehicleLAddressGetList: [],
  vehicleAttributes: [],
  vehicleTypes: [],
  allPlatesDetailItems: [],
  vehicleInfoDetailsState: {},
  limitInfoDetailsState: {},
  driverInfoDetailsState: {},
  postVehiclesResponse: {},
  loading: {
    vehicleLimitTypes: false,
    vehicleLimitValueTypes: false,
    vehicleLimitTypesDayRestrictionOperations: false,
  },
};

export const addCarPlateDetailSlice = createSlice({
  name: 'addCarPlateDetail',
  initialState,
  reducers: {
    resetCurrentLoadAddCarPlateDetail: (state) => {
      return initialState;
    },
    resetVehicleLimitWithValueTypes: (state) => {
      state.vehicleLimitTypes = [];
      state.vehicleLimitValueTypes = [];
      state.vehicleLimitTypesDayRestrictionOperations = [];
    },
    setVehicleDetailsState: (state, action) => {
      state.vehicleInfoDetailsState[action.payload.index] = action.payload.details;
    },
    setLimitDetailsState: (state, action) => {
      state.limitInfoDetailsState[action.payload.index] = action.payload.details;
    },
    setDriverDetailsState: (state, action) => {
      state.driverInfoDetailsState[action.payload.index] = action.payload.details;
    },
    setAllPlatesDetailItems: (state, action) => {
      if (action.payload.type === 'REMOVE') {
        const { id } = action.payload;
        state.allPlatesDetailItems = state.allPlatesDetailItems.filter((item) => item.id !== id);
      } else {
        const {
          id,
          plateNumber,
          vehicleDetails,
          limitDetails,
          driverDetails,
          selectCustomerVousList,
          selectVehicleDeviceTypeList,
        } = action.payload;

        const existingIndex = state.allPlatesDetailItems.findIndex((item) => item.id === id);

        if (existingIndex !== -1) {
          // Eğer item zaten varsa, sadece güncelle
          state.allPlatesDetailItems[existingIndex] = {
            ...state.allPlatesDetailItems[existingIndex],
            vehicleDetails:
              vehicleDetails || state.allPlatesDetailItems[existingIndex].vehicleDetails,
            limitDetails: limitDetails || state.allPlatesDetailItems[existingIndex].limitDetails,
            driverDetails: driverDetails || state.allPlatesDetailItems[existingIndex].driverDetails,
            selectCustomerVousList:
              selectCustomerVousList ||
              state.allPlatesDetailItems[existingIndex].selectCustomerVousList,
            selectVehicleDeviceTypeList:
              selectVehicleDeviceTypeList ||
              state.allPlatesDetailItems[existingIndex].selectVehicleDeviceTypeList,
          };
        } else {
          // Eğer item yoksa, yeni bir tane ekle
          state.allPlatesDetailItems.push({
            id,
            plateNumber,
            vehicleDetails,
            limitDetails,
            driverDetails,
            selectCustomerVousList,
            selectVehicleDeviceTypeList,
          });
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleLimitTypesDayRestrictionOperations.pending, (state) => {
        state.loading.vehicleLimitTypesDayRestrictionOperations = true;
      })
      .addCase(getVehicleLimitTypes.pending, (state) => {
        state.loading.vehicleLimitTypes = true;
      })
      .addCase(getVehicleLimitValueTypes.pending, (state) => {
        state.loading.vehicleLimitValueTypes = true;
      })
      .addCase(getVehicleDepartments.fulfilled, (state, action) => {
        state.vehicleDepartments = action?.payload || [];
      })
      .addCase(getVehicleFuelTypes.fulfilled, (state, action) => {
        state.vehicleFuelTypes = action?.payload || [];
      })
      .addCase(getVehicleCostCenter.fulfilled, (state, action) => {
        state.vehicleCostCenters = action?.payload || [];
      })
      .addCase(getVehicleLimitTypes.fulfilled, (state, action) => {
        state.loading.vehicleLimitTypes = false;
        state.vehicleLimitTypes = action?.payload || [];
      })
      .addCase(getVehicleLimitTypesDayRestrictionOperations.fulfilled, (state, action) => {
        state.loading.vehicleLimitTypesDayRestrictionOperations = false;

        // Yeni verileri önce birleştiriyoruz
        const combinedVehicleLimitTypes = [
          ...state.vehicleLimitTypesDayRestrictionOperations,
          ...action.payload,
        ];

        // Duplicate'ları kaldırıyoruz
        state.vehicleLimitTypesDayRestrictionOperations = combinedVehicleLimitTypes.filter(
          (item, index, self) =>
            index ===
            self.findIndex((t) => t.limitTypeId === item.limitTypeId && t.vouId === item.vouId),
        );
      })
      .addCase(getVehicleLimitValueTypes.fulfilled, (state, action) => {
        state.loading.vehicleLimitValueTypes = false;
        state.vehicleLimitValueTypes = action?.payload || [];
      })
      .addCase(getVehicleTypes.fulfilled, (state, action) => {
        state.vehicleTypes = action?.payload || [];
      })
      .addCase(getVehicleAttributes.fulfilled, (state, action) => {
        state.vehicleAttributes = action?.payload || [];
      })
      .addCase(getVehicleLAddressGetList.fulfilled, (state, action) => {
        state.vehicleLAddressGetList = action?.payload || [];
      })
      .addCase(getVehicleForThanksPage.fulfilled, (state, action) => {
        state.vehicleForThanksPage = action?.payload || [];
      })
      .addCase(postVehicles.fulfilled, (state, action) => {
        state.postVehiclesResponse = action?.payload;
      })
      .addCase(getVehicleDepartments.rejected, (state) => {
        state.VehicleDepartments = [];
      })
      .addCase(getVehicleCostCenter.rejected, (state) => {
        state.vehicleCostCenters = [];
      })
      .addCase(getVehicleLimitTypes.rejected, (state) => {
        state.loading.vehicleLimitTypes = false;
        state.vehicleLimitTypes = [];
      })
      .addCase(getVehicleLimitTypesDayRestrictionOperations.rejected, (state) => {
        state.loading.vehicleLimitTypesDayRestrictionOperations = false;
        state.vehicleLimitTypesDayRestrictionOperations = [];
      })
      .addCase(getVehicleLimitValueTypes.rejected, (state) => {
        state.loading.vehicleLimitValueTypes = false;
        state.vehicleLimitValueTypes = [];
      })
      .addCase(getVehicleTypes.rejected, (state) => {
        state.vehicleTypes = [];
      })
      .addCase(getVehicleAttributes.rejected, (state) => {
        state.vehicleAttributes = [];
      })
      .addCase(getVehicleLAddressGetList.rejected, (state) => {
        state.vehicleLAddressGetList = [];
      })
      .addCase(getVehicleForThanksPage.rejected, (state) => {
        state.vehicleForThanksPage = [];
      });
  },
});

export const {
  resetCurrentLoadAddCarPlateDetail,
  resetVehicleLimitWithValueTypes,
  setAllPlatesDetailItems,
  setVehicleDetailsState,
  setLimitDetailsState,
  setDriverDetailsState,
} = addCarPlateDetailSlice.actions;
